import { Routes, Route } from "react-router-dom";
import WebsiteLayout from "../components/layout/WebsiteLayout";
import Home from "../pages/website/Home";
import About from "../pages/website/About";
import Contact from "../pages/website/Contact";
import Careers from "../pages/website/Careers";
import JobDetails from "../pages/website/JobDetails";
import NewProductDevelopment from "../pages/website/Services/NewProductDevelopment";
import ProductSupportServices from "../pages/website/Services/ProductSupportServices";
import CloudSolutions from "../pages/website/Services/CloudSolutions";  
import GCCServices from "../pages/website/Services/GCCServices";
import CaseStudy from "../pages/website/Insights/CaseStudy";
import ProcessDrivenApproach from "../pages/website/OurApproach/ProcessDrivenApproach";
import EngagementModels from "../pages/website/OurApproach/EngagementModels";
import AiCoe from "../pages/website/OurApproach/AiCoe";
import Leadership from "../pages/website/About/Leadership";
import LifeAtSpringup from "../pages/website/About/LifeAtSpringup";
import ClientTestimonies from "../pages/website/Insights/ClientTestimonies";
import NotFound from "../pages/website/NotFound";
import BlogsListing from "../pages/website/Insights/Blogs";
import BlogPost from "../pages/website/Insights/BlogsPost";
import Clients from "../pages/website/Insights/Clients";
import GccBuildServices from "../pages/website/Services/GccBuildServices";
import PrivacyPolicy from "../pages/website/PrivacyPolicy";
import TermsOfUse from "../pages/website/TermsOfUse";
import CookiesPolicy from "../pages/website/CookiesPolicy";

const WebsiteRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <WebsiteLayout>
            <Home />
          </WebsiteLayout>
        }
      />
      <Route
        path="/about"
        element={
          <WebsiteLayout>
            <About />
          </WebsiteLayout>
        }
      />
      <Route
        path="/contact"
        element={
          <WebsiteLayout>
            <Contact />
          </WebsiteLayout>
        }
      />
      <Route
        path="/services/new-product-development"
        element={
          <WebsiteLayout>
            <NewProductDevelopment />
          </WebsiteLayout>
        }
      />
      <Route
        path="/services/product-support-services"
        element={
          <WebsiteLayout>
            <ProductSupportServices />
          </WebsiteLayout>
        }
      />
      <Route
        path="/services/cloud-solutions"
        element={
          <WebsiteLayout>
            <CloudSolutions />
          </WebsiteLayout>
        }
      />
      <Route
        path="/services/gcc-services"
        element={
          <WebsiteLayout>
            <GCCServices />
          </WebsiteLayout>
        }
      />
       <Route
        path="/careers"
        element={
          <WebsiteLayout>
            <Careers />
          </WebsiteLayout>
        }
      />
      <Route path="/careers/:id" 
      element={
          <WebsiteLayout>
            <JobDetails />
          </WebsiteLayout>
        } />
      <Route
        path="/insights/case-study"
        element={
          <WebsiteLayout>
            <CaseStudy />
          </WebsiteLayout>
        }
      />
      <Route
        path="/process-driven-approach"
        element={
          <WebsiteLayout>
            <ProcessDrivenApproach />
          </WebsiteLayout>
        }
      />
      <Route
        path="/engagement-models"
        element={
          <WebsiteLayout>
            <EngagementModels />
          </WebsiteLayout>
        }
      />
      <Route
        path="/ai-coe"
        element={
          <WebsiteLayout>
            <AiCoe />
          </WebsiteLayout>
        }
      />
      <Route
        path="/leadership"
        element={
          <WebsiteLayout>
            <Leadership />
          </WebsiteLayout>
        }
      />
      <Route
        path="/life-at-springup"
        element={
          <WebsiteLayout>
            <LifeAtSpringup />
          </WebsiteLayout>
        }
      />
      <Route
        path="/client-testimonies"
        element={
          <WebsiteLayout>
            <ClientTestimonies />
          </WebsiteLayout>
        }
      />
      <Route
        path="/blogs"
        element={
          <WebsiteLayout>
            <BlogsListing />
          </WebsiteLayout>
        }
      />
      <Route
        path="/blogs/:slug"
        element={
          <WebsiteLayout>
            <BlogPost />
          </WebsiteLayout>
        }
      />
      <Route
        path="/clients"
        element={
          <WebsiteLayout>
            <Clients />
          </WebsiteLayout>
        }
      />
      <Route
        path="/gcc-build-services"
        element={
          <WebsiteLayout>
            <GccBuildServices />
          </WebsiteLayout>
        }
      />

      <Route
        path="/privacy-policy"
        element={
          <WebsiteLayout>
            <PrivacyPolicy />
          </WebsiteLayout>
        }
      />
      <Route
        path="/terms-of-use"
        element={
          <WebsiteLayout>
            <TermsOfUse />
          </WebsiteLayout>
        }
      />
      <Route
        path="/cookies-policy"
        element={
          <WebsiteLayout>
            <CookiesPolicy />
          </WebsiteLayout>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default WebsiteRoutes;
